import {GoogleLogin} from '@react-oauth/google';
import {useUser} from 'contexts/UserContext';
import {setToken} from 'helpers/storage';
import {useNavigate} from 'react-router-dom';
import {useService} from 'services/hooks/useService';
import usersService from 'services/users';
import {Wallet} from 'lucide-react';

function LoginModule() {
  const {setUser} = useUser();
  const navigate = useNavigate();
  const useServiceUserMe = useService<User>(
    async () => usersService.me(),
    false,
  );

  return (
    <div className='h-[100dvh] items-center justify-center flex bg-background relative overflow-hidden'>
      {/* Background Glows */}
      <div className='absolute -top-[10%] -left-[10%] w-[50%] h-[50%] bg-primary/10 blur-[120px] rounded-full' />
      <div className='absolute -bottom-[10%] -right-[10%] w-[50%] h-[50%] bg-emerald-500/10 blur-[120px] rounded-full' />

      <div className='relative z-10 w-full max-w-[400px] px-8 py-12 text-center flex flex-col gap-10 items-center'>
        <div className='flex flex-col items-center gap-4'>
          <div className='w-20 h-20 rounded-[2rem] bg-primary text-primary-foreground flex items-center justify-center shadow-2xl shadow-primary/20 scale-110 mb-2'>
            <Wallet size={40} strokeWidth={1.5} />
          </div>
          <div className='space-y-1'>
            <h1 className='text-3xl font-extrabold tracking-tight text-gradient'>
              Expensy
            </h1>
            <p className='text-muted-foreground text-sm font-medium tracking-tight'>
              Simplify your expenses tracking
            </p>
          </div>
        </div>

        <div className='w-full flex flex-col gap-12 items-center'>
          <div className='text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground/60'>
            Welcome back
          </div>
          <div className='w-full flex justify-center'>
            <GoogleLogin
              onSuccess={async (credentialResponse) => {
                if (credentialResponse.credential) {
                  const rsp = await usersService.loginFromGoogle(
                    credentialResponse.credential,
                  );
                  if (rsp.status) {
                    setToken(rsp.data.token);
                    const rspUser = await useServiceUserMe.loader();
                    if (rspUser.status) {
                      setUser(rspUser.data);
                      navigate('/');
                    }
                  }
                }
              }}
              useOneTap
              theme='outline'
              shape='pill'
              onError={() => {}}
            />
          </div>
        </div>

        <footer className='mt-8'>
          <p className='text-xxs text-muted-foreground/40 font-medium'>
            Safe • Secure • Professional
          </p>
        </footer>
      </div>
    </div>
  );
}

export default LoginModule;
